import { fun } from "../../../../utils/firebase"

const searchTransferQuotesCallable = fun.httpsCallable("searchTransferQuotes")

export const searchTransferQuotes = async ({ bookingID, search }) => {
	try {
		const response = await searchTransferQuotesCallable({
			bookingID,
			search,
		})

		const { result, basketId = null, quotes = [], error = null, detail = null, search: normalizedSearch = {}, raw = {} } = response?.data || {}

		if (!result || error) {
			return {
				result: false,
				error: error || "Failed to search transfer quotes",
				detail,
			}
		}

		return {
			result: true,
			basketId,
			quotes,
			search: normalizedSearch,
			raw,
		}
	} catch (err) {
		console.log(err)
		return {
			result: false,
			error: "Failed to search transfer quotes",
			detail: err?.message || null,
		}
	}
}
